import styled, { css } from 'styled-components';

export const Text = styled.div`
  font: ${(props) => props.theme.fonts?.textBig};
  color: ${(props) => props.theme.colors?.greys?.darkest};

  ${(props) => {
    if (props.highlighted) {
      return css`
        font: ${(props) => props.theme.fonts?.textMiddleBold};
        color: ${(props) => props.theme.colors?.greys?.darkest};
      `;
    }
    if (props.deleteProduct) {
      return css`
        color: ${(props) => props.theme.colors?.greys?.darker};
        font: ${(props) => props.theme.fonts?.textBigHeight24};
      `;
    }
  }}
`;

export const GenericModalContentContainer = styled.div``;
